import ApiService from "../../../ApiService";

const UnitPreviewService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/unitpreview/loadscreenview", vo, successCallback, failureCallback);
    },
    saveUnitReferenceAnswer: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/unitpreview/saveunitreferenceanswer", vo, successCallback, failureCallback);
    },
};

export default UnitPreviewService;
